import { render } from "./viewArchiveTemplateInformation.vue?vue&type=template&id=162952b9&ts=true"
import script from "./viewArchiveTemplateInformation.vue?vue&type=script&lang=ts"
export * from "./viewArchiveTemplateInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__